


export default function initSwiper() {
  const Swiper = window.Swiper;
  if(Swiper) {
    document.querySelectorAll('.images-swiper').forEach(function(swiperEl){
      let resizeTimer;
      const next = swiperEl.querySelector(".swiper-button-next");
      const prev = swiperEl.querySelector(".swiper-button-prev");
      const slides = swiperEl.querySelectorAll('.swiper-slide');
      const wrap =swiperEl.querySelector(".swiper-wrapper");
      const length = slides.length;
      const cloneArray = [];

      if(length > 2 && length < 6) {
        cloneSlides();
        addClone();
      } else if (length === 2) {
        cloneSlides();
        cloneSlides();
        addClone();

      }
      function cloneSlides() {
        slides.forEach(function(slide) {
          cloneArray.push(slide.cloneNode(true));
        })
      }

      function addClone() {
        cloneArray.forEach(function(clone) {
          wrap.append(clone)
        })
      }

      new Swiper(swiperEl, {
        loop: true,
        initialSlide: 0,
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
        on: {
          init: function (swiper) {
            const nextSlide = swiper.slides[swiper.activeIndex + 1];
            if(!nextSlide) return;
            const imgHolder = nextSlide.querySelector('.img-holder, .video-holder');
            const style = window.getComputedStyle(imgHolder);
            const extraBottom =  parseFloat(style.paddingTop) + parseFloat(style.marginBottom);
            swiperEl.style.setProperty("--bottom-arrows", style.paddingTop);
            swiperEl.style.setProperty("--left-arrows", style.width);
            swiperEl.style.setProperty("--extra-bottom-arrows", extraBottom +'px');

          },
          resize: function(swiper) {
            clearTimeout(resizeTimer)
            resizeTimer = setTimeout(()=>{
              const nextSlide = swiper.slides[swiper.activeIndex + 1];
              if(!nextSlide) return;
              const imgHolder = nextSlide.querySelector('.img-holder, .video-holder');
              const style = window.getComputedStyle(imgHolder);
              const extraBottom =  parseFloat(style.paddingTop) + parseFloat(style.marginBottom);
              swiperEl.style.setProperty("--bottom-arrows", style.paddingTop);
              swiperEl.style.setProperty("--left-arrows", style.width);
              swiperEl.style.setProperty("--extra-bottom-arrows", extraBottom +'px');
            }, 100)
          },
        },
      });
    })
    document.querySelectorAll('.offcanvas-slider').forEach(function(swiperEl){
      const next = swiperEl.querySelector(".swiper-button-next");
      const prev = swiperEl.querySelector(".swiper-button-prev");
      const swiper = new Swiper(swiperEl, {
        loop: false,
        autoHeight: true,
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 'auto',
            spaceBetween: 15,
          },
          1200: {
            slidesPerView: 'auto',
            spaceBetween: 30,
          },

        },
        navigation: {
          nextEl: next,
          prevEl: prev
        },
        on: {
          init: function (swiper) {
            setTimeout(function() {
              swiper.updateAutoHeight(400)
            }, 100)
          },
        },
      });
    })
  }

}